import dynamic from 'next/dynamic'

export const SubotInline = dynamic(
  () =>
    import('components/organisms/subotInline').then((mod) => mod.SubotInline),
  {
    ssr: false,
  },
)

export const SubotInlineRevamp = dynamic(
  () =>
    import('@hhgtech/hhg-components/subot').then(
      (res) => res.SubotInlineRevampWithTheme,
    ),
  {
    ssr: false,
  },
)

export const InjectedRelatedPosts = dynamic(() =>
  import('components/organisms/relatedPosts/injectedRelatedPosts').then(
    (mod) => mod.InjectedRelatedPosts,
  ),
)
export const HealthConcern = dynamic(() =>
  import('components/organisms/healthConcernCarousel').then(
    (mod) => mod.HealthConcern,
  ),
)
export const CollapsibleFaqs = dynamic(() =>
  import('components/molecules/collapsibleFaqs').then(
    (mod) => mod.CollapsibleFaqs,
  ),
)
export const CareEmbedRecommendation = dynamic(
  () => import('components/molecules/careEmbedRecommendation'),
)
export const EmbeddedSpotlight = dynamic(() =>
  import('components/organisms/embedSpotlight').then(
    (mod) => mod.EmbeddedSpotlight,
  ),
)

export const EmbeddedCommunityNew = dynamic(() =>
  import('components/organisms/embeddedCommunity').then(
    (mod) => mod.EmbeddedCommunity,
  ),
)
export const BMICard = dynamic(() =>
  import('components/organisms/embededHeathToolCards/bmi').then(
    (mod) => mod.BMICard,
  ),
)
export const BMICardWrapper = dynamic(() =>
  import('components/organisms/embededHeathToolCards/embedBMI').then(
    (mod) => mod.BMICardWrapper,
  ),
)
export const BMRCard = dynamic(() =>
  import('components/organisms/embededHeathToolCards/bmr').then(
    (mod) => mod.BMRCard,
  ),
)
export const BMRCardWrapper = dynamic(() =>
  import('components/organisms/embededHeathToolCards/embedBMR').then(
    (mod) => mod.BMRCardWrapper,
  ),
)
export const DueDateCard = dynamic(() =>
  import('components/organisms/embededHeathToolCards/due-date').then(
    (mod) => mod.DueDateCard,
  ),
)
export const DueDateCardWrapper = dynamic(() =>
  import('components/organisms/embededHeathToolCards/embedDueDate').then(
    (mod) => mod.DueDateCardWrapper,
  ),
)
export const OvulationCardWrapper = dynamic(() =>
  import('components/organisms/embededHeathToolCards/embedOvulation').then(
    (mod) => mod.OvulationCardWrapper,
  ),
)
export const BabyGrowthCard = dynamic(() =>
  import('components/organisms/embededHeathToolCards/embedBabyGrowth').then(
    (mod) => mod.BabyGrowthCard,
  ),
)

export const OvulationCard = dynamic(() =>
  import('components/organisms/embededHeathToolCards/ovulation').then(
    (mod) => mod.OvulationCard,
  ),
)
export const PWGCard = dynamic(() =>
  import(
    'components/organisms/embededHeathToolCards/pregnancy-weight-gain'
  ).then((mod) => mod.PWGCard),
)
export const PWGCardWrapper = dynamic(() =>
  import('components/organisms/embededHeathToolCards/embedPwg').then(
    (mod) => mod.PWGCardWrapper,
  ),
)
export const THRCard = dynamic(() =>
  import('components/organisms/embededHeathToolCards/target-heart-rate').then(
    (mod) => mod.THRCard,
  ),
)
export const THRCardWrapper = dynamic(() =>
  import('components/organisms/embededHeathToolCards/embedTHR').then(
    (mod) => mod.THRCardWrapper,
  ),
)
export const BabyPoopCard = dynamic(() =>
  import('components/organisms/embededHeathToolCards/baby-poop').then(
    (mod) => mod.BabyPoopCard,
  ),
)
export const BabyVaccinationCard = dynamic(() =>
  import('components/organisms/embededHeathToolCards/baby-vaccination').then(
    (mod) => mod.BabyVaccinationCard,
  ),
)
export const ArticleRecommendation = dynamic(() =>
  import('components/molecules/articleRecommendation').then(
    (mod) => mod.ArticleRecommendation,
  ),
)
export const ContentItemAppBanner = dynamic(() =>
  import('./contentItem/appBanner').then((mod) => mod.ContentItemAppBanner),
)
export const ContentItemInterscrollerAd = dynamic(() =>
  import('./contentItem/interscrollerAd').then(
    (mod) => mod.ContentItemInterscrollerAd,
  ),
)
export const ContentItemVideoList = dynamic(() =>
  import('./contentItem/videoList').then((mod) => mod.ContentItemVideoList),
)
export const RelatedArticleCarousel = dynamic(() =>
  import('components/molecules/relatedArticleCarousel').then(
    (mod) => mod.RelatedArticleCarousel,
  ),
)
export const EmbeddedAffiliate = dynamic(() =>
  import('components/organisms/embeddedAffiliate').then(
    (mod) => mod.EmbeddedAffiliate,
  ),
)
export const ReadMore = dynamic(() =>
  import('./contentItem/readMore').then((mod) => mod.ReadMore),
)
export const PremiumContentBanner = dynamic(() =>
  import('components/atoms/premiumContentBanner').then(
    (mod) => mod.PremiumContentBanner,
  ),
)
export const ProductsWidget = dynamic(() =>
  import('components/molecules/productsWidget').then(
    (mod) => mod.ProductsWidget,
  ),
)

export const LeadGenSubscriptionBox = dynamic(
  () =>
    import('@hhgtech/hhg-components/lead').then(
      (res) => res.LeadGenSubscriptionBox,
    ),
  { ssr: false },
)
